document.addEventListener('DOMContentLoaded', function() {
    const contentArea = document.querySelector('.js-content-with-sidebar-page-content');
    const tocElement = document.querySelector('.js-content-with-sidebar-page-toc .content-with-sidebar-page__toc-list');

    if (!contentArea || !tocElement) {
        return;
    }

    // Select all H1 elements within the content area
    const headers = contentArea.querySelectorAll('h1, h2, h3, h4, h5, h6');

    headers.forEach((header, index) => {
        // Generate a unique ID for each header
        const id = `section-${index + 1}`;
        header.setAttribute('id', id);

        // Create a new list item for the Table of Contents
        const listItem = document.createElement('li');
        listItem.classList.add('content-with-sidebar-page__toc-item');

        // Create an anchor element linking to the header
        const anchor = document.createElement('a');
        anchor.classList.add('content-with-sidebar-page__toc-link');
        anchor.setAttribute('href', `#${id}`);
        anchor.textContent = header.textContent;

        // Append the anchor to the list item
        listItem.appendChild(anchor);

        // Append the list item to the TOC element
        tocElement.appendChild(listItem);
    });
});